const warnedMissingPlayers = new Set();

export const normalizeId = (value) => {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number') return `${value}`;
  if (!value || typeof value !== 'object') return '';
  const candidate = value.id || value._id || value.playerId || value.userId || value.user || value.value;
  if (typeof candidate === 'string') return candidate.trim();
  if (typeof candidate === 'number') return `${candidate}`;
  if (candidate && typeof candidate.toString === 'function') {
    const stringified = candidate.toString().trim();
    if (stringified && stringified !== '[object Object]') return stringified;
  }
  return '';
};

export const uniqueById = (values = []) => {
  const seen = new Set();
  return values.filter((value) => {
    const id = normalizeId(value);
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
};

const resolveName = (player = {}) => {
  if (typeof player === 'string') return player.trim();
  return (
    player?.name ||
    player?.playerName ||
    player?.fullName ||
    player?.displayName ||
    player?.label ||
    player?.personal?.fullName ||
    player?.user?.name ||
    player?.user?.fullName ||
    player?.user?.displayName ||
    ''
  );
};

const resolveEmail = (player = {}) => {
  if (!player || typeof player !== 'object') return '';
  return player?.email || player?.personal?.email || player?.user?.email || '';
};

export const buildPlayerDirectory = ({ players = [], directory = {}, teamData = [] } = {}) => {
  const map = new Map();

  [...players, ...teamData].forEach((player = {}) => {
    const id = normalizeId(player);
    if (!id) return;
    map.set(id, {
      id,
      name: resolveName(player),
      email: resolveEmail(player),
    });
  });

  Object.entries(directory || {}).forEach(([id, player = {}]) => {
    const normalizedId = normalizeId(id) || normalizeId(player);
    if (!normalizedId) return;
    map.set(normalizedId, {
      id: normalizedId,
      name: resolveName(player),
      email: resolveEmail(player),
    });
  });

  return map;
};

export const resolveRosterByIds = ({ rosterIds = [], playerDirectory, matchId = '' } = {}) =>
  (rosterIds || [])
    .map((entry, index) => {
      const id = normalizeId(entry);
      if (!id) return null;
      const fromDirectory = playerDirectory?.get(id) || null;
      const fallbackName = resolveName(entry);
      const fallbackEmail = resolveEmail(entry);
      if (!fromDirectory && matchId) {
        const warningKey = `${matchId}:${id}`;
        if (!warnedMissingPlayers.has(warningKey)) {
          warnedMissingPlayers.add(warningKey);
        }
      }
      return {
        id,
        name: fromDirectory?.name || fallbackName || `Player ${index + 1}`,
        email: fromDirectory?.email || fallbackEmail || '',
      };
    })
    .filter(Boolean);
